// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BarChartController from "./bar_chart_controller"
application.register("bar-chart", BarChartController)

import BillingToggleController from "./billing_toggle_controller"
application.register("billing-toggle", BillingToggleController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DesktopUploadController from "./desktop_upload_controller"
application.register("desktop-upload", DesktopUploadController)

import DoughnutChartController from "./doughnut_chart_controller"
application.register("doughnut-chart", DoughnutChartController)

import FeedbackWidgetController from "./feedback_widget_controller"
application.register("feedback-widget", FeedbackWidgetController)

import FormPanelController from "./form_panel_controller"
application.register("form-panel", FormPanelController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LabelModalController from "./label_modal_controller"
application.register("label-modal", LabelModalController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PendingProjectController from "./pending_project_controller"
application.register("pending-project", PendingProjectController)

import PhotoImportController from "./photo_import_controller"
application.register("photo-import", PhotoImportController)

import PiecesController from "./pieces_controller"
application.register("pieces", PiecesController)

import PwaInstallController from "./pwa_install_controller"
application.register("pwa-install", PwaInstallController)

import ReportIssueController from "./report_issue_controller"
application.register("report-issue", ReportIssueController)

import ResetPasswordModalController from "./reset_password_modal_controller"
application.register("reset-password-modal", ResetPasswordModalController)

import ResizablePanelController from "./resizable_panel_controller"
application.register("resizable-panel", ResizablePanelController)

import ScanUploadController from "./scan_upload_controller"
application.register("scan-upload", ScanUploadController)

import SheetVisualizerController from "./sheet_visualizer_controller"
application.register("sheet-visualizer", SheetVisualizerController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TutorialVideoController from "./tutorial_video_controller"
application.register("tutorial-video", TutorialVideoController)

import UserMenuController from "./user_menu_controller"
application.register("user-menu", UserMenuController)
